import Images from '../imgs/ccImgs/imgMap';

export const DELETE = 8;

export const getCursorPosition = (textDom) => {
  let cursorPos = 0;
  if (textDom.setSelectionRange) {
    // webkit support
    textDom.focus();
    cursorPos = textDom.selectionStart;
  }
  return cursorPos;
};

export const setCursorPosition = (textDom, pos) => {
  if (textDom.setSelectionRange) {
    textDom.focus();
    textDom.setSelectionRange(pos, pos);
  }
};

export const cardNumberImgShow = (cardType) => {
  let cardArts = [];
  if (cardType !== 'INVALID') {
    cardArts = (Array.isArray(Images[cardType]) ? Images[cardType] : [ Images[cardType] ])
      .map(image => ({ image, cardType }));
  }
  return cardArts;
};

export const formatCardNumber = (value) => {
  return value?.replace(/\s/g, '').replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
};